import * as React from "react";

const PremiumIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#171718"
            d="m17.675 21.2.875-2.85-2.3-1.85h2.85l.9-2.8.9 2.8h2.85l-2.325 1.85.875 2.85-2.3-1.775zM14 30.5v-7.725a7.7 7.7 0 0 1-1.475-2.4A7.9 7.9 0 0 1 12 17.5q0-3.35 2.325-5.675T20 9.5t5.675 2.325T28 17.5a7.9 7.9 0 0 1-.525 2.875q-.525 1.35-1.475 2.4V30.5l-6-2zm6-7q2.5 0 4.25-1.75T26 17.5t-1.75-4.25T20 11.5t-4.25 1.75T14 17.5t1.75 4.25T20 23.5m-4 4.025 4-1.025 4 1.025v-3.1a8.4 8.4 0 0 1-1.887.787A7.7 7.7 0 0 1 20 25.5a7.7 7.7 0 0 1-2.113-.288A8.4 8.4 0 0 1 16 24.426z"
        ></path>
    </svg>
);

export default PremiumIconSVG;
